
export default function ProductShowcase() {
  const products = [
    {
      name: "狮虎精元丸",
      subtitle: "Lion Tiger Essence Pills",
      description: "融合云南道地药材与泰国天然草本，专为现代男性精力提升而研制",
      image: "https://public.readdy.ai/ai/img_res/1a1f1f0fb681d2d277dbb04adeb602ba.jpg",
      features: ["精力提升", "体质调理", "天然配方"],
      price: "¥298"
    },
    {
      name: "虎骨强身茶",
      subtitle: "Tiger Bone Strength Tea",
      description: "传承古法配制，结合现代工艺，为忙碌男性打造的日常养生茶饮",
      image: "https://readdy.ai/api/search-image?query=Premium%20Chinese%20herbal%20tea%20in%20elegant%20packaging%20with%20traditional%20design%20elements%2C%20luxury%20tea%20box%20with%20gold%20details%2C%20professional%20product%20photography%2C%20clean%20background%2C%20representing%20strength%20and%20wellness&width=400&height=400&seq=product-002&orientation=squarish",
      features: ["日常养生", "古法传承", "现代工艺"],
      price: "¥188"
    },
    {
      name: "狮王活力膏",
      subtitle: "Lion King Vitality Balm",
      description: "泰国草本精华与中医理论完美结合，外用调理，内外兼修",
      image: "https://readdy.ai/api/search-image?query=Premium%20herbal%20balm%20in%20sophisticated%20dark%20jar%20with%20gold%20labeling%2C%20luxury%20skincare%20product%20photography%2C%20traditional%20Chinese%20medicine%20external%20application%2C%20clean%20background%2C%20representing%20vitality%20and%20wellness&width=400&height=400&seq=product-003&orientation=squarish",
      features: ["外用调理", "草本精华", "内外兼修"],
      price: "¥228"
    }
  ];

  return (
    <section className="py-20 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-xl md:text-2xl font-bold text-[#2f3673] mb-4">
            精选产品系列
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            每一款产品都承载着三地精粹的智慧结晶，为现代男性量身定制的养生解决方案
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100"
              data-product-shop
            >
              {/* Product Image */}
              <div className="relative h-80 bg-gray-50 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-4 right-4">
                  <div className="bg-[#f7931d] text-white px-2 py-1 rounded-full text-xs font-medium">
                    热销
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="text-base font-bold text-[#2f3673] mb-1">
                    {product.name}
                  </h3>
                  <p className="text-xs text-gray-500 font-medium">
                    {product.subtitle}
                  </p>
                </div>

                <p className="text-xs text-gray-600 leading-relaxed mb-4">
                  {product.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {product.features.map((feature, featureIndex) => (
                    <span
                      key={featureIndex}
                      className="bg-orange-50 text-[#f7931d] px-2 py-1 rounded-full text-xs font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* Price and Action */}
                <div className="flex items-center justify-between">
                  <div className="text-lg font-bold text-[#2f3673]">
                    {product.price}
                  </div>
                  <button className="bg-[#f7931d] text-white px-4 py-2 rounded-full text-xs font-medium hover:bg-[#e6841a] transition-colors duration-300 cursor-pointer whitespace-nowrap">
                    立即购买
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-[#2f3673] to-[#f7931d] rounded-2xl p-6 text-white">
            <h3 className="text-lg font-bold mb-4">
              探索完整产品系列
            </h3>
            <p className="text-sm mb-6 opacity-90">
              更多精心研制的养生产品，等待您的发现
            </p>
            <a 
              href="/products"
              className="inline-block bg-white text-[#2f3673] px-6 py-2 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              查看全部产品
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
